import React from 'react';
import { MenuItem as ChakraMenuItem, MenuItemProps } from '@chakra-ui/react';

export default function MenuItem(props: MenuItemProps) {
  return <ChakraMenuItem iconSpacing="15px" {...props} />;
}
